export default __webpack_public_path__ + "static/media/2099.f4c58257.png";